/** Decimal places for embodied carbon quantity fields across A1/A2/A3. */
export const EMBODIED_CARBON_QTY_DECIMALS = 2;

/** @deprecated Use EMBODIED_CARBON_QTY_DECIMALS */
export const EMBODIED_CARBON_REFERENCE_QTY_DECIMALS = EMBODIED_CARBON_QTY_DECIMALS;

export const EMBODIED_CARBON_FUNCTIONAL_UNIT_DECIMALS =
  EMBODIED_CARBON_QTY_DECIMALS;

function roundEmbodiedCarbonQty(value: number): number {
  if (!Number.isFinite(value)) return NaN;
  const factor = 10 ** EMBODIED_CARBON_QTY_DECIMALS;
  return Math.round(value * factor) / factor;
}

function formatEmbodiedCarbonQty(value: number): string {
  const rounded = roundEmbodiedCarbonQty(value);
  if (!Number.isFinite(rounded)) return "";
  return rounded.toFixed(EMBODIED_CARBON_QTY_DECIMALS);
}

function formatEmbodiedCarbonQtyFromUnknown(value: unknown): string {
  if (value == null || value === "") return "";
  const n = Number(String(value).replace(/,/g, "").trim());
  if (!Number.isFinite(n)) return String(value ?? "");
  return formatEmbodiedCarbonQty(n);
}

function roundEmbodiedCarbonQtyFromUnknown(value: unknown): number {
  const n = Number(String(value ?? "").replace(/,/g, "").trim());
  if (!Number.isFinite(n)) return NaN;
  return roundEmbodiedCarbonQty(n);
}

export const roundEmbodiedCarbonReferenceQty = roundEmbodiedCarbonQty;
export const formatEmbodiedCarbonReferenceQty = formatEmbodiedCarbonQty;
export const formatEmbodiedCarbonReferenceQtyFromUnknown =
  formatEmbodiedCarbonQtyFromUnknown;
export const roundEmbodiedCarbonReferenceQtyFromUnknown =
  roundEmbodiedCarbonQtyFromUnknown;

export const roundEmbodiedCarbonFunctionalUnit = roundEmbodiedCarbonQty;
export const formatEmbodiedCarbonFunctionalUnit = formatEmbodiedCarbonQty;
export const formatEmbodiedCarbonFunctionalUnitFromUnknown =
  formatEmbodiedCarbonQtyFromUnknown;
export const roundEmbodiedCarbonFunctionalUnitFromUnknown =
  roundEmbodiedCarbonQtyFromUnknown;
